import AirDatepicker from 'air-datepicker'

const moduleName = 'datepicker';

export function datepicker() {
    document.querySelectorAll('.js-datepicker').forEach((input) => {
        const container = input.parentNode;
        new AirDatepicker(input, {
            selectedDates: [new Date()],
            isMobile: true,
            autoClose: true,
            container: container
        });
    });
}
